import {
    AsyncPipe,
    NgTemplateOutlet,
} from "@angular/common";
import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    input,
    InputSignal,
    Output,
    Signal,
    ViewChild,
} from "@angular/core";
import { RouterModule } from "@angular/router";
import { Game } from "@Front-end/seed/models/game";
import { ChangeFavoriteDirective } from "@Front-end/seed/modules/favorite-games";
import { FullScreenDirective } from "@Front-end/seed/modules/full-screen";
import { UserDirective } from "@Front-end/seed/modules/user";
import { NgLetDirective } from "@Front-end/ui/directives/ng-let";
import { ModalOpenType } from "@Front-end/ui/models/modal";
import { IconComponent } from "@Front-end/ui/modules/icon";
import { LocalizeRouterModule } from "@gilsdav/ngx-translate-router";
import { TranslateModule } from "@ngx-translate/core";
import {
    FeatureFlags,
    hasFeatureFlag,
} from "../../constants/feature-flags.constants";
import { TournamentsSidebarComponent } from "../../features/tournaments/components/tournaments-sidebar/tournaments-sidebar.component";
import { LivechatButtonDirective } from "../../modules/live-chat/livechat-button.directive";
import { BonusAmountComponent } from "../../modules/shared/bonus-amount/bonus-amount.component";
import {
    SidePanelManagerService,
    SidePanelType,
} from "../../services/side-panel-manager.service";
import { AppPopupsService } from "../../store/services/app-popups.service";

@Component({
    selector: "ls-bottom-menu",
    templateUrl: "./bottom-menu.component.html",
    styleUrls: ["./bottom-menu.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        TranslateModule,
        RouterModule,
        IconComponent,
        LocalizeRouterModule,
        ChangeFavoriteDirective,
        UserDirective,
        AsyncPipe,
        NgLetDirective,
        FullScreenDirective,
        NgTemplateOutlet,
        BonusAmountComponent,
        LivechatButtonDirective,
    ],
})
export class BottomMenuComponent {
    constructor(
        private appPopupService: AppPopupsService,
        private sidePanelManagerService: SidePanelManagerService,
    ) {
    }

    @ViewChild(TournamentsSidebarComponent)
    public tournamentsSidebarComponent!: TournamentsSidebarComponent;

    @Output()
    public lsToggleMenu = new EventEmitter<void>();

    @Output()
    public lsToggleTournamentsSidebar = new EventEmitter<void>();

    @Output()
    public lsToggleBottomMenu = new EventEmitter<void>();

    public game: InputSignal<Game | null> = input<Game | null>(null);
    public isUser: InputSignal<boolean> = input<boolean>(false);
    public isGamePage: InputSignal<boolean> = input<boolean>(false);
    public isTournamentsSidebarOpen: InputSignal<boolean> = input<boolean>(false);
    public isMenuOpen: Signal<boolean> = this.sidePanelManagerService.isMenuOpen;
    public isProfilePage = input.required<boolean>();

    public showSport: boolean = hasFeatureFlag(FeatureFlags.SPORT);
    public hasTournaments: boolean = hasFeatureFlag(FeatureFlags.TOURNAMENTS);

    public toggleMenu(): void {
        this.sidePanelManagerService.toggle(SidePanelType.Menu);
        this.lsToggleMenu.emit();
    }

    public closeMenu(): void {
        this.sidePanelManagerService.closeMenu();
    }

    public toggleTournamentsSidebar(): void {
        this.lsToggleTournamentsSidebar.emit();
    }

    public toggleBottomMenu(): void {
        this.lsToggleBottomMenu.emit();
    }

    public openSearchPopup(): void {
        this.sidePanelManagerService.closeMenu();
        this.appPopupService.fireOpenSearchPopup(ModalOpenType.MANUAL);
    }
}
